module.exports = __webpack_public_path__ + "media/images/athletes/4319-ea2bdf1188736932cce7913e51d5b6b2.png";